import dotProp from 'dot-prop-immutable'
import { FRAMES_ARE_LOADING, FRAMES_FAILED, FRAMES_LOADED, CURRENT_FRAME_SIZE } from '../constants/framesActions'

const initialState = {
  isLoading: false,
  errMessage: '',
  frames: [],
  current: {
    width: 0,
    height: 0,
  },
}

export default function(state = initialState, action) {
  switch (action.type) {
    case FRAMES_ARE_LOADING:
      return dotProp.set(state, 'isLoading', true)
    case FRAMES_LOADED:
      state = dotProp.set(state, 'frames', action.frames)
      state = dotProp.set(state, 'isLoading', false)

      return state
    case FRAMES_FAILED:
      state = dotProp.set(state, 'isLoading', false)
      state = dotProp.set(state, 'errMessage', action.message)

      return state
    case CURRENT_FRAME_SIZE:
      return dotProp.set(state, 'current', action.size)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/frames.js